import Slider from "react-slick";
import "../../style/mobile/dashboard/M_Ads.css";
import slide1 from "../../../assets/mobile/dashboard/adrien-olichon-RCAhiGJsUUE-unsplash.jpg";
import slide2 from "../../../assets/mobile/dashboard/steve-johnson-dVRD8E3XUGs-unsplash.jpg";

let data = [
  {
    id: 1,
    img: slide1,
    title: "اولین بوت کمپ برنامه نویسی اندروید",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 2,
    img: slide2,
    title: "اولین بوت کمپ تصویرسازی",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 3,
    img: slide1,
    title: "اولین بوت کمپ برنامه نویسی جاوا",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 4,
    img: slide2,
    title: "اولین بوت کمپ طراحی کاراکتر",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
];

const M_Ads = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    className: "m-ExamStore-tab-content-slider-item",
  };
  return (
    <div className="M_Ads">
      <Slider {...settings}>
        {data.map((item) => (
          <div className="M_Ads-item" key={item.id}>
            <img src={item.img} alt="ads-img" />
            <div className="M_Ads-item-text-box">
              <div className="M_Ads-item-text-box-title">{item.title}</div>
              <div className="M_Ads-item-text-box-subtitle">
                {item.subtitle}
              </div>
              <div className="M_Ads-item-text-box-btn">اطلاعات بیشتر</div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default M_Ads;
